var _style, _polyline, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLocationBanner = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "0,512 0,0 512,0 512,512 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432.1,123c16.4,0,29.7-13.3,29.7-29.7c0-16.4-13.3-29.7-29.7-29.7c-16.4,0-29.7,13.3-29.7,29.7 C402.4,109.6,415.7,123,432.1,123z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311.4,397.3h162.9c7.2,0,13.1-5.9,13.1-13.1V161.6c13.6-23.9,24.5-48.5,24.5-65c0-44-35.8-79.9-79.9-79.9 c-36.6,0-67.5,24.7-76.9,58.4H13.1C5.9,75.1,0,81,0,88.3v295.9c0,7.2,5.9,13.1,13.1,13.1h162.9H311.4z M432.1,50.3 c23.6,0,42.9,19.2,42.9,42.9c0,23.6-19.2,42.9-42.9,42.9c-23.6,0-42.9-19.2-42.9-42.9C389.2,69.6,408.5,50.3,432.1,50.3z  M410.1,371.1h-16.6h-26.3h-341V101.4h326.3c4.8,44.1,71.4,131.8,74.4,135.6c0.6,0.8,1.4,1.4,2.3,1.9c0.9,0.4,1.9,0.7,2.9,0.7 s2-0.2,2.9-0.7c0.9-0.4,1.7-1.1,2.3-1.9c1.1-1.5,11.3-14.9,23.9-33.4v167.4h0h-24.8H410.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5,195.2c-0.3-0.9-0.9-1.6-1.7-2.2c-0.8-0.5-1.7-0.8-2.6-0.8h0l-7.7,0c-0.9,0-1.8,0.3-2.6,0.8c-0.8,0.5-1.4,1.3-1.7,2.2 l-26.9,72.3c-0.3,0.7-0.3,1.4-0.3,2.2c0.1,0.7,0.4,1.4,0.8,2c0.4,0.6,1,1.1,1.6,1.5c0.7,0.3,1.4,0.5,2.1,0.5h7c1.9,0,3.6-1.2,4.3-3 l8-21.4h23.3l8.1,21.4c0.3,0.9,0.9,1.6,1.7,2.2c0.8,0.5,1.7,0.8,2.6,0.8h7c0.8,0,1.6-0.2,2.2-0.6c0.7-0.4,1.3-0.9,1.7-1.6 c0.4-0.7,0.6-1.4,0.7-2.2c0-0.8-0.1-1.6-0.5-2.3L212.5,195.2z M198.7,233.6l5.7-15.3l5.8,15.3H198.7z M280.4,191.9h-29.1 c-1.2,0-2.4,0.5-3.2,1.3c-0.9,0.9-1.3,2-1.3,3.2v72.2c0,1.2,0.5,2.4,1.3,3.2c0.9,0.9,2,1.3,3.2,1.3h29.1c22.9,0,41.5-18.2,41.5-40.7 C321.9,210.2,303.3,191.9,280.4,191.9z M280.4,257.5h-17.9v-49.9h17.9c14.2,0,25.7,11.2,25.7,25 C306.2,246.4,294.6,257.5,280.4,257.5z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocationBanner, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/locationBanner.df08f4e0.svg";
export { ForwardRef as ReactComponent };